module.exports = ".admin-container {\n  padding: 15px; }\n"